import React, { Component } from 'react';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBlock,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,

} from "reactstrap";
import * as Constant from '../../../constants/AppConstants';
import axios from 'axios';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { CSVLink } from 'react-csv';
import { loadProgressBar } from 'axios-progress-bar';
loadProgressBar()

// or in ECMAScript 5
var ReactBSTable = require('react-bootstrap-table');
//var BootstrapTable = ReactBSTable.BootstrapTable;
//var TableHeaderColumn = ReactBSTable.TableHeaderColumn;



class DSAReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dsaleads: [],
      drop: {},
      //        dashboardData: [],
      loading: true,
      //        average_disbursed_amount: '',
      //        total_disbursed_amount: '',
      limit: 25,
      offset: 0,
      //        query:'',
      //        lead_status:'',
      //        loan_status:'',
      applicationStatus: '',
      sort_col: '',
      filters: '',
      sort: '',
      fromdt: '',
      todt: ''


    };
    //      this.getDashboard = this.getDashboard.bind(this);
    this.nextpage = this.nextpage.bind(this);
    this.previouspage = this.previouspage.bind(this);
    this.handleUserInput = this.handleUserInput.bind(this);
    this.getDSA_Reports = this.getDSA_Reports.bind(this);

  }


  componentDidMount() {
    this.getDSA_Reports();
    // this.getDashboard();
  }

  nextpage() {
    this.setState({
      offset: this.state.offset + this.state.limit
    }, this.getDSA_Reports);
  }

  previouspage() {

    var offset = this.state.offset - this.state.limit;
    if (offset < 0) {
      offset = 0;
    }
    this.setState({
      offset: offset
    }, this.getDSA_Reports);
  }

  handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, function () {
    });
  }


  getDSA_Reports() {
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
      mode: Constant.GET_DSA_REPORTS,
      filters: this.state.applicationStatus,
      fromdt: this.state.fromdt,
      todt: this.state.todt,

      //         "filters[from_date]": this.state.from_date,
      //         "filters[to_date]": this.state.to_date,
      sort: this.state.sort,
      sort_col: this.state.sort_col,
      total_rows: this.state.total_rows,
      limit: this.state.limit,
      offset: this.state.offset
    });
    // console.log("Auth token: " + window.localStorage.getItem(Constant.AUTH_TOKEN));
    this.setState({
      loading: true,

    });
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
        'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
      .then(function (response) {
        if (response.status == 200) {
          // console.log(response);
          self.setState(prevState => ({
            dsaleads: response.data.dsaleads,
            //               total_rows: response.data.total_rows,
            loading: false
          }));
        } else {
          self.setState(prevState => ({
            loading: false
          }));
        }
      })
      .catch(function (error) {
        // console.log("Error");
        // console.log(error);
        self.setState(prevState => ({
          loading: false
        }));
      });
  }

  render() {

    //const selectRow = {
    //    mode: 'checkbox',  // multi select
    //     columnWidth: '60px'
    //  };
    return (
      <div>


        <Card>
          <CardBlock>
            <div className="panel-heading active mb-4">
              <h3 className="panel-title">
                <b>DSA Reporting</b>
              </h3>
            </div>

            <div className="filters pt-3 pb-3">
              <select name="applicationStatus" id="select" className="deepsearchselect col-md-2 mr-3" value={this.state.applicationStatus || ''} onChange={(event) => this.handleUserInput(event)}>
                <option value="">Application status</option>
                <option value="complete">Complete</option>
                <option value="rejected">Rejected</option>
                <option value="processing">Processing</option>
                <option value="incomplete">Incomplete</option>
                <option value="pending_otp">Pending OTP</option>
              </select>
              <input type="date" id="fromdt" name="fromdt" className="col-md-2 mr-3" placeholder="From Date" value={this.state.fromdt} onChange={(event) => this.handleUserInput(event)}></input>
              
              {/* <DatePicker selected={this.state.fromdt} onChange={(event) => this.handleUserInput(event)}/> */}
              
              
              <input type="date" id="todt" name="todt" className="col-md-2 mr-3" value={this.state.todt} onChange={(event) => this.handleUserInput(event)}></input>
              <Button className="deepearchsubmit mr-3" onClick={this.getDSA_Reports}>Search</Button>
              <Button className="submitCSV">
                <CSVLink data={this.state.dsaleads} className="submitCSV">ExportCSV</CSVLink>
              </Button>
            </div>

            <ReactTable

              data={this.state.dsaleads}

              columns={[{
                Header: 'Customer ID',
                accessor: 'cust_id'
              }, {
                Header: 'Customer Name',
                accessor: 'name'
              }, {
                Header: 'Agent Name',
                accessor: 'agent_name'
              }, {
                Header: 'Salary',
                accessor: 'salary'
              }, {
                Header: 'Create Date',
                accessor: 'loan_creation_date'
              }, {
                Header: 'Comment Date',
                accessor: 'comment_date'
              }, {
                Header: 'City Name',
                accessor: 'city_name'
              }, {
                Header: 'Loan Status',
                accessor: 'loan_status'
              }
                , {
                Header: 'Lead Status',
                accessor: 'lead_status'
              }, {
                Header: 'Current Pending Task',
                accessor: 'application_status'
              }, {
                Header: 'Last Comment',
                accessor: 'last_comment'
              }, {
                Header: 'Approved Amount',
                accessor: 'approved_amount'
              }, {
                Header: 'Disbursal Date',
                accessor: 'transfer_date'
              }, {
                Header: 'Disbursed Amount',
                accessor: 'disbursal_amount',

                Cell: row => (row.value === null ? "Not Available" : row.value)
              }]}


              showPaginationBottom={true}
              className="-striped -highlight"
              onFetchData={this.getDashboard}
              loading={this.state.loading}

            />




          </CardBlock>
        </Card>
      </div>
    )
  }
}

export default DSAReports;



// WEBPACK FOOTER //
// ./src/views/Pages/DSAreports/DSAReports.js